import { countries as countriesData } from 'localizations';

import { CountryData, CountriesData } from '../config/types';

import { debug } from './debug';

const getCountryData = (countryCode: string): CountryData | null => {
  const countries = countriesData as CountriesData;
  return countries[countryCode] ?? null;
};

const extractCountryName = (country: CountryData, locale?: string): string => {
  const fallbackChain = locale
    ? [
        country.names[locale],
        country.names['en-US'],
        country.names['en-GB'],
        Object.values(country.names)[0],
      ]
    : [
        country.names['en-US'],
        country.names['en-GB'],
        Object.values(country.names)[0],
      ];

  return fallbackChain.find((name) => name) ?? '';
};

const handleCountryNotFound = (countryCode: string): string => {
  debug(`Country code "${countryCode}" not found in countries data`);
  return countryCode;
};

export const getCountryName = (
  countryCode: string,
  locale?: string,
): string => {
  const country = getCountryData(countryCode);

  return country
    ? extractCountryName(country, locale) || countryCode
    : handleCountryNotFound(countryCode);
};

export const getEnglishCountryName = (countryCode: string): string =>
  getCountryName(countryCode);
